import styled from 'styled-components/macro';
import { useTranslation } from 'react-i18next';

import { Label1 } from '../Text';

const AutofillContainer = styled.div`
  margin-top: 0.375rem;
  display: flex;
  flex-direction: row;
  gap: 0.25rem;
`;

const AutofillOption = styled(Label1)<{ selected: boolean; disabled: boolean }>`
  border: 0.125rem solid rgba(0, 0, 0, 0);
  padding: 0.25rem 0.625rem;
  border-radius: 0.75rem;
  cursor: pointer;

  ${({ disabled, theme, selected }) => {
    if (disabled) {
      return `
        background: ${theme.bg3};
        border-color: rgba(0,0,0,0);
        color: ${theme.bg5};
      `;
    }
    if (selected) {
      return `
        background: ${theme.bg4};
        border-color: ${theme.gray2};
        color: ${theme.white};
      `;
    }
    return `
      background: ${theme.bg0};
      border-color: rgba(0,0,0,0);
      color: ${theme.gray3};
    `;
  }}

  ${({ disabled, theme }) => {
    if (!disabled) {
      return `
        &:hover {
          box-shadow: ${theme.hover4};
          cursor: pointer;
        }

        &:enabled:active {
          border-color: rgba(0, 0, 0, 0);
          background: ${theme.bg3};
          box-shadow: none;
        }
      `;
    }
    return '';
  }}
`;

interface AutofillProps {
  fillAmounts: string[];
  setAutofill: (index: number) => void;
  selected: number;
  disabled?: boolean;
}

export function Autofill({ fillAmounts, setAutofill, selected, disabled = false }: AutofillProps) {
  const { t } = useTranslation();
  return (
    <AutofillContainer>
      {fillAmounts.map((value, index) => (
        <AutofillOption
          as="button"
          disabled={disabled}
          key={value}
          onClick={() => setAutofill(index)}
          selected={index === selected}
        >
          {t(value)}
        </AutofillOption>
      ))}
    </AutofillContainer>
  );
}

Autofill.defaultProps = {
  disabled: false,
};
